import { render } from "./alert.vue?vue&type=template&id=66c988ac&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"

import "./alert.vue?vue&type=style&index=0&id=66c988ac&scoped=true&lang=css"

import exportComponent from "/home/devbuildsseatshopcom/dev.builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c988ac"]])

export default __exports__